module.exports = __webpack_public_path__ + "/images/cover-it-recibiendo-dinero.855ad03.jpg";